import $ from "jquery";
import React from 'react';
import { createRoot } from "react-dom/client";
import noUiSlider from "nouislider";
import deferAction from "scripts/utils/deferAction";
import eSputnik from "./eSputnik";
import { FBQviewCategory } from "./FacebookPixel/view-category";
import { GAViewItemList } from "./ga/view_item_list";
import { sortFilters } from "./listing/sort-filters";
import updateH1 from "./listing/updateH1";
import updateLangLinks from "./listing/updateLangLinks";
import createBreadcrumbs from "./listing/createBreadcrumbs";
import preloader from "./preloader";
import { seedLabels} from "scripts/components/get-label"
import currencyFormat, { currencyFormatWithSign } from "scripts/utils/currencyFormat";
import { ProductCardSkeleton } from "scripts/components/react/ProductCard/ProductCard";

let skeletonRoot = null;
let skeletonContainer = null;

export const renderSkeletonProducts = () => {
  unmountSkeletonProducts();

  const skeletonProducts = document.createElement("div");
  skeletonProducts.classList.add("products-skeleton-holder");
  const pagination = document.querySelector(".catalogue-list__pagination");

  if (pagination) {
    pagination.before(skeletonProducts);
  }

  skeletonContainer = skeletonProducts;
  skeletonRoot = createRoot(skeletonProducts);
  skeletonRoot.render(Array.from({length: 8}).map((_, index) => <ProductCardSkeleton isAuth={false} key={index} />));
}

export const unmountSkeletonProducts = () => {
  if (skeletonRoot) {
    skeletonRoot.unmount();
    skeletonRoot = null;
  }
  if (skeletonContainer) {
    skeletonContainer.remove();
    skeletonContainer = null;
  }
}

const deleteProductCardsFromList = () => {
    document
      .querySelectorAll(".catalogue-list .product-card")
      .forEach((card, index) => {
        if (index > 29) {
            card.remove();
        }
      });
}

const AJAX = "";

export const createSliderRange = (min, max, breakpoints = 2) => {
  // normalize inputs. null/undefined -> 0
  // Backend may send null for min/max when there are discontinuous all products
  const minVal = min ?? 0;
  const maxVal = max ?? 0;

  // both zero -> make max 1
  if (minVal === 0 && maxVal === 0) {
    return { min: 0, max: 1 };
  }

  // equal values -> expand max by 1
  if (minVal === maxVal) {
    return { min: minVal, max: maxVal + 1 };
  }

  // too few breakpoints -> no intermediate stops
  if (breakpoints <= 2) {
    return { min: minVal, max: maxVal };
  }

  const logMin = Number.isFinite(Math.log(minVal)) ? Math.log(minVal) : 0;
  const logMax = Number.isFinite(Math.log(maxVal)) ? Math.log(maxVal) : 0;
  const range = { min: minVal };

  for (let i = 1; i < breakpoints - 1; i++) {
    const fraction = i / (breakpoints - 1);
    const value = Math.exp(logMin + fraction * (logMax - logMin));
    const percentage = Math.round(fraction * 100);

    if (percentage === 0 || percentage === 100 || Number.isNaN(value)) {
      // eslint-disable-next-line no-continue
      continue;
    }
    range[`${percentage}%`] = Math.round(value);
  }

  range.max = maxVal;
  return range;
};

const catalogue = () => {
  eSputnik.CategoryPage({
    categoryKey: window.categoryKey || 0
  });
  const filterRoot = $(".js_filter");
  const labels = {
    open: filterRoot.attr("data-more"),
    close: filterRoot.attr("data-close"),
  };
  const filterLimit = 7;

  const openFilterMenu = () => {
    const opener = $(".aside-item__title");
    $(document).on("click", ".aside-item__title", function openMenu() {
      const $this = $(this);

      opener.not($this).removeAttr("active");
      $this.toggleClass("active");
    });
  };

  const showMoreFilters = () => {
    $(document).on("click", ".options-more", function moreFilters() {
      $(this)
        .parents(".aside-item")
        .toggleClass("active");
    });
  };

  const showSortMenu = () => {
    const opener = $(".sort-menu");

    opener.on("click", (e) => {
      const { target } = e;

      if (
        $(target).hasClass("title") ||
        $(target).closest(".select__current").length
      ) {
        opener.toggleClass("active");
      }
      if (
        !$(target).closest(".sort-menu").length ||
        $(target).closest(".select__item").length
      ) {
        opener.removeClass("active");
        $("html").removeClass("overflow");
      }
    });
    $(document).mouseup((e) => {
      if (!opener.is(e.target) && opener.has(e.target).length === 0) {
        opener.removeClass("active");
      }
    });
  };

  const mobileMenu = () => {
    const menu = $(".mobile-menu");

    const open = () => {
      const opener = $(".mobile-opener");

      opener.on("click", function openMenu() {
        const $this = $(this);
        const target = $this.data("target");

        deferAction(() => {
          if (target === undefined) {
            $this.siblings(".mobile-menu").addClass("active");
          } else {
            $(`.mobile-menu[data-target="${target}"]`).addClass("active");
          }
          $("html").addClass("overflow");
        });
      });
    };

    const close = () => {
      menu.on("click", (e) => {
        const { target } = e;

        deferAction(() => {
          if (
            !$(target).closest(".mobile-content").length ||
            $(target).hasClass("close")
          ) {
            menu.removeClass("active");
            $("html").removeClass("overflow");
          }
        });
      });
    };

    open();
    close();
  };

  const sliderInit = () => {
    const stepsSlider = document.getElementById("slider");

    if (stepsSlider !== null) {
      const minInput = document.getElementById("minInput");
      const maxInput = document.getElementById("maxInput");
      const inputs = [minInput, maxInput];
      const minValue = +$(stepsSlider).attr("data-min");
      const maxValue = +$(stepsSlider).attr("data-max");
      const selectedMin = +$(stepsSlider).attr("data-selected-min");
      const selectedMax = +$(stepsSlider).attr("data-selected-max");
      const isOnePrice = minValue === maxValue;

      noUiSlider.create(stepsSlider, {
        start: [selectedMin, selectedMax],
        connect: true,
        range: createSliderRange(minValue, maxValue, 5),
      });

      // if min and max values are the same => disable slider and inputs
      if (isOnePrice) {
        [...inputs, stepsSlider].forEach((el) => {
          el.setAttribute("disabled", "disabled")
        });
      }

      stepsSlider.noUiSlider.on("update", (values, handle) => {
        inputs[handle].value = parseInt(values[handle], 10);
      });
      const handles = document.querySelectorAll(".noUi-handle");
      handles[0].setAttribute("aria-labelledby", 'price-label');
      handles[1].setAttribute("aria-labelledby", 'price-label');

      $(document)
        .on("change", "#minInput,#maxInput", function updateSlider() {
          const index = $(this).index() - 1;

          const priceSlider = $("#slider");
          const priceMin = priceSlider.attr("data-min");
          const priceSliderMin = priceSlider.attr("data-selected-min");

          if (
            this.id === "maxInput" &&
            (this.value === priceSliderMin || !this.value)
          ) {
            this.value = priceSlider.attr("data-selected-max");
          } else if (
            this.id === "minInput" &&
            (this.value === priceMin || !this.value)
          ) {
            this.value = priceSlider.attr("data-selected-min");
          }

          stepsSlider.noUiSlider.setHandle(index, this.value);
        })
        .on("keyup", "#minInput,#maxInput", function inputChange() {
          this.value = this.value.replace(/[^0-9/.]/g, "");
        });
    }
  };

  const ajaxListingPagination = () => {
    const location = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const getUrl = window.location.pathname.split("f/")[0];
    let getSlug = getUrl.split("/catalog/")[1];
    const locale = $("html").attr("lang");
    const paginationHolder = $(".catalogue-list__pagination");
    let searchParameter = "";
    let price = "";
    let page = Number($(".pagination li.active a").last().text()) || 1;
    let lastPageCount = Number($(".pagination .last a").text()) || 1;
    let historyUrl = "";
    let sortValue = urlParams.get("sort")
      ? `?sort=${urlParams.get("sort")}`
      : "";
    let filtersArr = [];
    let priceFilterMarkup = "";
    let isMore = false;
    let showMoreWasUsed = false;
    let queryTimeout = "";
    const PRODUCT_REQUEST_DELAY = 500;
    let filters =
      window.location.pathname.indexOf("/f/") > -1
        ? window.location.pathname
            .split("/f/")[1]
            .split("/")
            .filter((a) => a.indexOf("-price-") === -1)
            .join("/")
        : "";

    const minPricePrefix = "min-price";
    const maxPricePrefix = "max-price";
    if (location.indexOf(minPricePrefix) > -1) {
      price += `${minPricePrefix}-${
        window.location.pathname
          .split("/")
          .find((i) => i.indexOf(minPricePrefix) > -1)
          .match(/[0-9]+/g)[0]
      }/`;
    }
    if (location.indexOf(maxPricePrefix) > -1) {
      price += `${maxPricePrefix}-${
        window.location.pathname
          .split("/")
          .find((i) => i.indexOf(maxPricePrefix) > -1)
          .match(/[0-9]+/g)[0]
      }/`;
    }

    if (location.indexOf("?q=") !== -1) {
      [searchParameter] = location
        .split("?q=")
        .pop()
        .split("&");
    } else if (location.indexOf("&q=") !== -1) {
      [searchParameter] = location
        .split("&q=")
        .pop()
        .split("&");
    }

    // set initial price filter markup
    (function initializePriceMarkup() {
      const $priceRange = $('[data-code="priceRange"]');
      const $priceMin = $('[data-code="min-price"]');
      const $priceMax = $('[data-code="max-price"]');

      if ($priceRange.length > 0) {
        priceFilterMarkup = $priceRange.get(0).outerHTML;
      }
      if ($priceMin.length > 0) {
        priceFilterMarkup = $priceMin.get(0).outerHTML;
      }
      if ($priceMax.length > 0) {
        priceFilterMarkup = $priceMax.get(0).outerHTML;
      }
    })();

    const setFiltersLength = (responseOptions, { price }) => {
      const createCheckboxLayout = (option, variant, params) => 
        `<label class="checkbox ${variant.products_count === 0 ? 'disabled' : ''}">
            <input
                name="${variant.option_value_slug}"
                id="${variant.option_code}-${variant.option_value_slug}"
                type="checkbox"
                ${params.checked ? "checked" : ""}
                class="container-input"
                data-sort-in-url="${option.sort_in_url}${variant.id}"
            />
            <a class="text" href="${variant.url}">${variant.value}</a>
            <span class="checkmark"></span>
        </label>`;
      
      let html = "";
      $.each(responseOptions, (key, item) => {
        let subfilter = "";
        const checkedFilters = [];
        $.each(item.variants, (index, variant) => {
          const checked =
            window.location.pathname
              .replaceAll("/", " ")
              .trim()
              .split(" ")
              .indexOf(
                `${variant.option_code}-${variant.option_value_slug}`
              ) > -1
              ? "checked"
              : "";
          if (checked) {
            checkedFilters.push(variant);
          }
        });
        $.each(checkedFilters, (index, variant) => {
          subfilter += createCheckboxLayout(item, variant, { checked: true });
        });
        $.each(
          item.variants.slice(checkedFilters.length),
          (index, variant) => {
            subfilter += createCheckboxLayout(item, variant, { checked: false });
          }
        );
        const showMore =
          item.variants.length > filterLimit
            ? `<div class="options-more">
                    <span
                        class="options-more__text"
                        data-more="${labels.open.replace(
                          ":count",
                          item.variants.length - filterLimit
                        )}"
                        data-close="${labels.close}"
                    >
                        <svg class="icon-arrow"><use xlink:href="#arrow"/></svg>
                    </span>
                </div>`
            : "";
        const grid =
          ["size", "kolichestvo_kamney", "po_alfavitu"].indexOf(
            item.main_code
          ) > -1
            ? "number_grid"
            : "";
        html += `<div class="aside-item">
                  <div class="aside-item__title ${
                    checkedFilters.length > 0 ? "active has-selected" : ""
                  } flex-c">
                    <span class="text">${item.name}</span>
                    <svg class="icon-arrow">
                        <use xlink:href="#arrow"/>
                    </svg>
                  </div>
                  <div class="aside-item__dropdown ${grid}">
                      <div class="options">
                          ${subfilter}
                          ${showMore}
                      </div>
                  </div>
              </div>`;
      });

      $(".js_filter").html(html);

      const priceSlider = $("#slider");
      priceSlider.attr("data-min", price.min);
      priceSlider.attr("data-max", price.max);
      priceSlider.attr("data-selected-min", price["min-price"]);
      priceSlider.attr("data-selected-max", price["max-price"]);
    };

    const filtersHolderLayout = (lang, priceFilters, filters) => {
      if (!$(".selected-filters").length) {
        const layout = `<div class="catalogue-nav__selected flex-c">
                          <div class="title">
                            ${lang.filter_select_count}
                          </div>
                          <div class="selected-filters flex-c">
                            ${priceFilters}${filters}
                          </div>
                          <a href="#" class="remove">${lang.filter_cancel_selected}</a>
                        </div>`;

        $(".catalogue-nav__sort").before(layout);
      } else {
        const selectedFiltersTitle = $(".catalogue-nav__selected .title");

        selectedFiltersTitle.text(lang.filter_select_count);
      }
    };

    const selectedFilterLayout = (title, filter, id, isPrice) => {
      const layout = `<div class="filter" data-code="${id}">
                        ${title}: <strong>${filter}</strong>
                      </div>`;

      if (isPrice === true) {
        priceFilterMarkup = `<div class="filter" data-code="${id}">
                                ${title} ${filter}
                              </div>`;
      } else {
        filtersArr.push(layout);
      }
    };

    const generatePagin = (currentPage, lastPage, url) => {
      lastPageCount = Number(lastPage) || lastPageCount;
      let layout = "";
      const pagination = $(".pagination__list");
      const seoBlock = $(".block-seo");
      const hasUrlParams = url.indexOf("?") > -1;
      const divider = hasUrlParams ? "&" : "?";

      if (lastPage !== 1) {
        let loop = 0;
        const arrowsPrevPage = currentPage - 1 >= 1 ? currentPage - 1 : 1;
        const arrowsNextPage =
          currentPage + 1 <= lastPage ? currentPage + 1 : lastPage;
        const dots = `<li class="dots"><span><svg class="icon-dots"><use xlink:href="#dots"></use></svg></span></li>`;
        const arrow = (className) =>
          `<li class=" pagination-button ${className}"><a aria-label="${className === "prev" ? window.phrases.prev : window.phrases.next}" href="${url}${divider}page=${
            className === "prev" ? arrowsPrevPage : arrowsNextPage
          }""><svg class="icon-arrow"><use xlink:href="#arrow"></use></svg></a></li>`;
        const paginationItem = (number, className = "") =>
          `<li class="${className}${
            number === currentPage ? " active" : ""
          }"><a href="${url}${
            +number !== 1 ? `${divider}page=${number}` : ""
          }">${number}</a></li>`;

        // generate loop
        if (lastPage >= 5 && currentPage >= 7) {
          loop = 7;
        } else if (lastPage >= 5 && currentPage < 7) {
          loop = 6;
        }

        if (lastPage - 4 < loop && lastPage - 4 > 0) {
          loop = lastPage - 4;
        }
        // ==================
        // button prev
        if (currentPage > 1) {
          layout += arrow("prev");
        }

        // items from 1 to 2
        if (lastPage >= 2) {
          const className = lastPage === 2 ? "last" : "";

          layout += paginationItem(1, "first");

          // fake item for last page on mobile 
          if (className === "last" && currentPage === lastPage) {
            layout += paginationItem(2, "fake");
          }

          layout += paginationItem(2, className);
        }

        // generate list
        // dot
        if (loop === 7 && lastPage >= 12) {
          layout += dots;
        }

        for (let i = 1; i <= loop; i += 1) {
          let number = 2;

          if (loop === 6) {
            number = i + 2;
          } else if (loop === 7) {
            number = lastPage - 2 - (loop - i);
            if (lastPage - 6 >= currentPage) {
              if (i < 4) {
                number = currentPage - (4 - i);
              } else if (i === 4) {
                number = currentPage;
              } else {
                number = currentPage + (i - 4);
              }
            }
          } else {
            number += i;
          }

          layout += paginationItem(number);
        }

        // dot
        if ((loop === 6 && lastPage > 11) || (loop === 7 && lastPage > 12)) {
          if (currentPage < lastPage - 5) {
            layout += dots;
          }
        }

        // items from LastPage - 1  to LastPage
        if (lastPage >= 3) {
          if (lastPage !== 3) {
            layout += paginationItem(lastPage - 1);
          }

          // fake item for last page on mobile
          if (lastPage === currentPage) {
            layout += paginationItem(lastPage, "fake");
          }

          layout += paginationItem(lastPage, "last");
        }

        // button next
        if (currentPage < lastPage) {
          layout += arrow("next");
        }
      }

      if (currentPage !== 1) {
        seoBlock.hide();
      } else {
        seoBlock.show();
      }

      if (pagination.length === 0 && lastPage !== 1) {
        const catalog = $(".js_catalog_list");
        const showMoreText = catalog.attr("data-show-more");
        const paginationContainer = `<div class="catalogue-list__pagination">
                                        <div class="wb-btn btn-white"><span>${showMoreText}</span></div>
                                        <div class="pagination">
                                            <ul class="pagination__list flex-c-c">${layout}</ul>
                                        </div>
                                    </div>`;
        catalog.append(paginationContainer);
      } else {
        pagination.html(layout);
      }
    };

    const generateLabels = (labelsList) => {
      const renderLabel = (l) => {
        const style = l.icon
          ? `background-color: ${l.color};`
          : `background-color: ${l.color}1A; color: ${l.color};`
        const content = l.icon ? `<img class="icon" title="${l.title}" src="${l.icon}">` : l.title;
        if (!l.description && !l.link) {
          return `<div class="product-card__label" style="${style};"">${content}</div>`
        } else {
          return `<button class="product-card__label" aria-label="${l.title}" style="${style};" data-label-id="${l.id}" aria-expanded="false">${content}</button>`
        }
      };
      const textLabels = labelsList.filter(l => !l.icon);
      const imageLabels = labelsList.filter(l => l.icon);
      return [...textLabels, ...imageLabels].map(renderLabel).join('');
    };

    const generateProducts = (products, auth, empty) => {
      const layout = [];
      const catalogueList = $(".catalogue-list");

      unmountSkeletonProducts();
      if (products.length) {
        products.forEach((item) => {
          if (item.labels?.length) {
            seedLabels(item.labels)
          }
          if (item.type && item.type === "banner") {
            const template = `<div class="product-collection"><a href='${item.url}'><img loading="lazy" src="${item.image}" alt="${item.title}"/></a></div>`;
            layout.push(template);
          } else {
            const isEnabled = !!(item.availability && item.enabled);
            const hasDiscount = isEnabled && item.discount_percent && item.old_price > item.price;
            const hasLabels = item.labels && item.labels.length > 0;
            const hasCredit = item.credit && item.credit.length > 0 && item.creditFromPrice;

            const image = item.image_webp
              ? `<picture><source type="image/webp" srcset="${item.image_webp}"><img class="image" src="${item.image}" alt=""></picture>`
              : `<img class="image" src="${item.image}" alt="">`;

            const topLabels = isEnabled && hasLabels
              ? generateLabels(item.labels)
              : !isEnabled && item.phrases.status
                ? `<div class="product-card__label product-card__label--disabled">${item.phrases.status}</div>`
                : '';

            const heart = isEnabled
              ? auth
                ? `<div class="product-card__like js_favorite favorite ${item.isFavorite ? 'active' : ''}"><svg class="icon-favorite"><use xlink:href="#favorite"/></svg></div>`
                : `<div class="product-card__like favorite modal-btn ${item.isFavorite ? 'active' : ''}" data-target="modal-favorite"><svg class="icon-favorite"><use xlink:href="#favorite"/></svg></div>`
              : '';

            const labelPopup = isEnabled && hasLabels
              ? `<div class="product__discount_bg product__label-popup hide js_product_label_info"></div>`
              : '';

            const oldPriceRow = hasDiscount
              ? `<div class="price__old-row"><div class="price__old">${currencyFormatWithSign(item.old_price)}</div><div class="price__discount">-${item.discount_percent}<span>%</span></div></div>`
              : '';

            const bonusBtn = isEnabled && item.showBonusBlock
              ? `<button class="product-buttons__item product-buttons__bonus js_toggle_discount" aria-label="${item.phrases.discount_title}"><svg class="icon-pay-discount"><use xlink:href="#pay-discount"/></svg></button>`
              : '';

            const cartBtn = isEnabled
              ? `<a href="${item.slug}" class="wb-btn btn-green product-buttons__cart buy "><svg class="icon-cart"><use xlink:href="#cart"/></svg>${item.phrases.buy_button}</a>`
              : '';

            const buttons = isEnabled
              ? `<div class="product-buttons">${bonusBtn}</div>`
              : '';

            const loansBar = isEnabled && hasCredit
              ? `<div class="product-card__loans">${item.credit.map(({code}) => `<div class="credit__item"><svg class="icon icon-b_${code}"><use xlink:href="#b_${code}"/></svg></div>`).join('')}
                <div class="credit__text">
                  ${phrases.product.buy_credit_from_to_small.replace(':count', currencyFormat(item.creditFromPrice))}
                </div>
              </div>`
              : '';

            const template = `<div class="product-card ${!isEnabled ? 'disabled' : ''}">
            <div class="product-card__content" data-id="${item.id}">
              <a href="${item.slug}" class="js_ga_select" data-sku="${item.sku}">
                <div class="product-card__image flex-c-c">
                  ${image}
                </div>
                <div class="title">${item.name_without_brand}</div>
              </a>
              <div class="product-card__top">
                <div class="product-card__labels">
                  ${topLabels}
                  ${labelPopup}
                </div>
                ${heart}
              </div>
              <div class="product-card__info">
                <div class="product-card__price-row">
                  <div class="price">
                    ${oldPriceRow}
                    <div class="price__current">${item.format_price}</div>
                  </div>
                  ${buttons}
                </div>
                ${cartBtn}
                ${loansBar}
                ${
                  auth && item.showBonusBlock
                    ? `<div class="product__footer js_toggle_discount">
                          <svg class="icon-percent hide_mob">
                              <use xlink:href="#pay-discount"/>
                          </svg>
                          <div class="product__footer_text hide_mob">${item.phrases.discount}</div>
                          <div class="product__footer_number hide_mob">${item.bonuses.discount_percent} %</div>
                          <div class="product__footer_plus hide_mob">+</div>
                          <svg class="icon-pay-bonus hide_mob">
                              <use xlink:href="#pay-bonus"/>
                          </svg>
                          <div class="product__footer_text hide_mob">${item.phrases.cb}</div>
                          <div class="product__footer_number hide_mob">${item.bonuses.cashback_price}</div>
                          <div class="product__footer_get_discount visible_mob">${item.phrases.discount_title}</div>
                          <svg class="product__footer_question">
                              <use xlink:href="#question"/>
                          </svg>
                          <svg class="product__footer_close">
                              <use xlink:href="#close"/>
                          </svg>
                      </div>
                      <div class="product__discount_bg hide js_product_discount_info">
                          <div class="prod__discount js_prod_bg tooltip__outer">
                              <svg class="product__discount_close js_close_discount">
                                  <use xlink:href="#close"/>
                              </svg>
                              <div class="product__discount_title">${item.phrases.discount_title}</div>
                              <div class="product__discount_li">
                                  <svg class="icon-percent">
                                      <use xlink:href="#pay-discount"/>
                                  </svg>
                                  <div>${item.phrases.discount}</div>
                                  <div class="product__discount_val">${item.bonuses.discount_percent} %</div>
                              </div>
                              <div class="product__discount_li">
                                  <svg class="icon-calendar">
                                      <use xlink:href="#calendar"/>
                                  </svg>
                                  <div>${item.phrases.bd}</div>
                                  <div class="product__discount_val">${item.bonuses.birthday_discount} %</div>
                              </div>
                              <div class="product__discount_li">
                                  <svg class="icon-pay-bonus">
                                      <use xlink:href="#pay-bonus"/>
                                  </svg>
                                  <div>${item.phrases.cb}</div>
                                  <div class="product__discount_val">${item.bonuses.cashback_price}</div>
                              </div>
                              <div class="product__discount_footer">
                                  <span>${item.phrases.price}</span>
                                  <span class="product__discount_price">${item.bonuses.price_with_discount}</span>
                              </div>
                          </div>
                      </div>`
                    : ""
                  }
                  ${!auth && item.showBonusBlock
                    ? `<div class="product__footer js_toggle_discount">
                          <div class="product__footer_get_discount" data-nosnippet>${item.phrases.get_discount}</div>
                          <svg class="product__footer_question">
                              <use xlink:href="#question"/>
                          </svg>
                          <svg class="product__footer_close">
                              <use xlink:href="#close"/>
                          </svg>
                      </div>
                      <div class="product__discount_bg hide js_product_discount_info">
                          <div class="prod__discount js_prod_bg tooltip__outer">
                              <svg class="product__discount_close js_close_discount">
                                  <use xlink:href="#close"/>
                              </svg>
                              <div class="product__discount_title">${item.phrases.get_discount_title}</div>
                              <div class="product__discount_subtitle">${item.phrases.reg_text}</div>
                              <div class="product__discount_li">
                                  <svg class="icon-percent">
                                      <use xlink:href="#pay-discount"/>
                                  </svg>
                                  <div>${item.phrases.discount}</div>
                                  <div class="product__discount_val">${item.bonuses.discount_percent} %</div>
                              </div>
                              <div class="product__discount_li">
                                  <svg class="icon-calendar">
                                      <use xlink:href="#calendar"/>
                                  </svg>
                                  <div>${item.phrases.bd}</div>
                                  <div class="product__discount_val">${item.bonuses.birthday_discount} %</div>
                              </div>
                              <div class="product__discount_li">
                                  <svg class="icon-pay-bonus">
                                      <use xlink:href="#pay-bonus"/>
                                  </svg>
                                  <div>${item.phrases.cb}</div>
                                  <div class="product__discount_val">${item.bonuses.cashback_price}</div>
                              </div>
                              <div class="product__discount_mt">
                                  <a class="product__discount_footer_link modal-btn" data-ga="listing" data-target="modal-login" href="">${item.phrases.button_text} <svg class="product__register_icon" width="22" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7h21.5m0 0L15 .5M21.5 7L15 13.5" stroke="#00502F" stroke-linejoin="round"/></svg></a>
                              </div>
                          </div>
                      </div>`
                    : ""
                  }
              </div>
            </div>
          </div>`;

            layout.push(template);
          }
        });
      } else {
        layout.push(`<div class="not-found">${empty}</div>`);
      }

      if (isMore) {
        $(".catalogue-list__pagination").before(layout);
      } else {
        catalogueList
          .find(".product-card, .not-found, .product-collection")
          .remove();
        catalogueList.prepend(layout);
      }
    };

    const generateCategoriesLine = (categories) => {
      const catalogueCategoriesList = document.querySelector(
        '.js_catalogue_categories_root'
      );
      if (!catalogueCategoriesList || !categories) return;

      const categoriesListItems = categories
        .map(
          ({ name, url, slug }) => `<li class="catalogue-categories__item">
                              <a href="${url}" class="catalogue-categories__link" data-slug=${slug}>${name}</a>
                              </li>`
        )
        .join('');
      if (categoriesListItems.length === 0) {
        $('.js_catalogue_categories_root').slideUp({
          complete() {
            catalogueCategoriesList.innerHTML = categoriesListItems;
          }});
      } else {
        catalogueCategoriesList.innerHTML = categoriesListItems;
        $('.js_catalogue_categories_root').slideDown();
      }
    };

    const updatePriceRange = (priceProps) => {
      // Destrucutre price props and convert them to numbers
      const { min, max, "min-price": minFilter, "max-price": maxFilter } = priceProps;
      const isOnePrice = min === max;
      const slider = document.getElementById("slider");
      const interactiveSliderElements = document.querySelectorAll(
        "#minInput, #maxInput, #slider",
      );

      // if min and max values are the same => disable slider and inputs
      interactiveSliderElements.forEach((el) => {
        el[isOnePrice ? "setAttribute" : "removeAttribute"]("disabled", "disabled")
      });

      // if min and max values are the same => set slider range to [min, max + 1]
      // else set slider range to [min, max]
      slider.noUiSlider.updateOptions({
        start: [minFilter, maxFilter],
        range: createSliderRange(min, max, 5),
      });



      // if (min !== max) {
      //   slider.removeAttribute("disabled")
      //   $("#minInput, #maxInput").removeAttr("disabled")
      //   slider.noUiSlider.updateOptions({
      //     start: [minFilter, maxFilter],
      //     range: {
      //       min,
      //       max,
      //     },
      //   })
      // } else {
      //   slider.setAttribute("disabled", "disabled")
      //   $("#minInput, #maxInput").attr("disabled", "disabled")
      //   slider.noUiSlider.updateOptions({
      //     start: [minFilter, maxFilter],
      //     range: {
      //       min,
      //       max: max + 1,
      //     },
      //   })
      // }
    }

    const generateQuery = (scrollToTop, isFiltersEnabled = true, delay = 0, expectedData = "full") => {
      /** location pathname without query params and filters. 
      * @type {string}
      */

      let clearUrl = getUrl.split("?")[0];
      filtersArr = [];

      clearTimeout(queryTimeout);

      filters = "";

      // Get filters from URL
      const filtersFromUrl = window.location.pathname
        .split("f/")?.[1]
        ?.split("?")[0]
        .replace(/\/$/, "")
        .split("/")
        .filter((filterString) => filterString.indexOf("-price-") === -1)

      // Write filters from URL when they are not in DOM
      filtersFromUrl?.forEach((currentFilter) => {
        // Find filter element by id
        const filterEl = document.getElementById(currentFilter);
        if (!filterEl) {
          filters += `${currentFilter}/`;
        }
      });
    
      const filterOptions = {};
      const checkedFilters = $(
        '.catalogue-aside__menu .container-input:checked'
      );
      checkedFilters.each((key, item) => {
        const $this = $(item);
        const id = $this.attr("id");
        const itemText = $this.next(".text").text();
        const title = $this
          .parents(".aside-item")
          .find(".aside-item__title .text")
          .text();

        filters += `${id}/`;
        const [option, variant] = id.split(/-([\s\S]*)/);
        filterOptions[option] = {
          sort_in_url: '',
          variants: [
            ...(filterOptions[option]?.variants || []),
            {
              id: $this.data('sort-in-url'),
              slug: variant,
            },
          ],
        };

        selectedFilterLayout(title, itemText, id);
      });

      let pageParameter = "";
      if (page > 1) {
        pageParameter = sortValue === "" ? `?page=${page}` : `&page=${page}`;
      }

      if ($(".selected-filters").length) {
        $(".selected-filters").html("");
        $(".selected-filters").append(priceFilterMarkup, filtersArr.join(""));
      }

      const filtersSeparator = price === "" && filters === "" ? "" : "f/";

      searchParameter = decodeURI(searchParameter);
      let qParameter = "";

      if (searchParameter !== "") {
        qParameter =
          page === 1 && sortValue === ""
            ? `?q=${searchParameter}`
            : `&q=${searchParameter}`;
      }

      historyUrl = `${price}${filters}`;

      let filterString = historyUrl;

      filterString = sortFilters(filterString, filterOptions);

      // Make sure the filter string doesn't end with '/'
      filterString = filterString.replace(/\/$/, '');

      const slug = getSlug !== "" && getSlug !== undefined
        ? `slug=${getSlug.split("/")[0]}&`
        : "";

      queryTimeout = setTimeout(() => {
        const filtersLenght = $(
          '[data-target="filterMenu"] .mobile-menu__head .title span'
        );
        $.ajax({
          url: `${AJAX}/api/catalog/get-filter-and-products`,
          type: "get",
          data: `${slug}page=${page}&sort=${
            sortValue !== "" ? sortValue.split("=")[1] : "default"
          }&q=${searchParameter}&locale=${locale}&filter_string=${
            isFiltersEnabled ? filterString : ""
          }&expectedData=${expectedData}`,
          dataType: "json",
          beforeSend: () => {
            preloader(true);
          },
          success: (success) => {
            const isProductsOnly = expectedData === "products";
            const successPagin = success.products.pagination;

            if (isProductsOnly) {
              historyUrl = filterString ? `${filterString}/` : "";
            } else {
              filters = sortFilters(filters, success.filter.options);
              historyUrl = `${price}${filters}`;
            }

            if (clearUrl.split('catalog/')[1] === '' && getSlug)
              clearUrl += `${getSlug}/`;

            window.history.pushState(
              "",
              "",
              `${clearUrl}${filtersSeparator}${historyUrl}${sortValue}${pageParameter}${qParameter}`
            );

            if (!isProductsOnly) {
              filtersHolderLayout(success.phrases, priceFilterMarkup, filtersArr);
            }

            generatePagin(
              successPagin.current_page,
              successPagin.last_page,
              clearUrl + filtersSeparator + historyUrl + sortValue + qParameter
            );
            generateProducts(
              success.products.data,
              success.isUserAuth,
              success.phrases?.empty
            );

            if (!isProductsOnly) {
              setFiltersLength(success.filter.options, {
                price: success.filter.price,
              });
              createBreadcrumbs(success.breadcrumbs);

              updateH1(success.meta_data);
            }

            const updateMetaDataHTML = () => {
              const currentMetaTitle = document.querySelector("meta[name='title']");
              const currentMetaDescription = document.querySelector("meta[name='description']");

              if (!isProductsOnly) {
                document.title = success.meta_data.title;
                currentMetaTitle && (currentMetaTitle.content = success.meta_data.meta_title);
                currentMetaDescription && (currentMetaDescription.content = success.meta_data.meta_description);
                return;
              }

              const pagePrefixRe = /^(Сторінка|Страница|Page number) №\d+\.\s*/;
              const pagePrefix = success.phrases?.page_number_title
                ?.replace(":number", successPagin.current_page) || "";
              const withPagePrefix = (text) => pagePrefix + text.replace(pagePrefixRe, "");

              document.title = withPagePrefix(document.title);
              currentMetaTitle && (currentMetaTitle.content = withPagePrefix(currentMetaTitle.content));
              currentMetaDescription && (currentMetaDescription.content = withPagePrefix(currentMetaDescription.content));
              const h1 = document.querySelector(".wb-head .wb-title");
              h1 && (h1.textContent = withPagePrefix(h1.textContent));
            }
            updateMetaDataHTML();
            generateCategoriesLine(success.categories);

            page = successPagin.current_page;
            paginationHolder.removeClass("disabled");

            updateLangLinks(success.slugArray);
            const showMoreBtn = document.querySelector(".catalogue-list__pagination .btn-white");
            if (showMoreBtn) {
              showMoreBtn.classList.toggle("hide", successPagin.current_page === successPagin.last_page)
            }

            isMore = false;

            if (!isProductsOnly) {
              updatePriceRange(success.filter.price);

              // Active filters
              const activeFilters = document.querySelectorAll(".catalogue-nav__selected .filter");
              const filtersMenuOpener = document.querySelector(".catalogue-aside__button");
              const itemsFoundPhrase = document.querySelector(".search-founded")
              if (activeFilters.length) {
                $(".catalogue-nav__selected").show();
                filtersMenuOpener.classList.add("active");
                itemsFoundPhrase && itemsFoundPhrase.classList.add("visually-hidden");
              } else {
                $(".catalogue-nav__selected").hide();
                filtersMenuOpener.classList.remove("active");
                itemsFoundPhrase && itemsFoundPhrase.classList.remove("visually-hidden")
              }

              const filterProductsCountPhrase = success.phrases.filter_select_count.split(" ").slice(1).join(" ");
              filtersLenght.text(`(${filterProductsCountPhrase})`);
            }

            FBQviewCategory(success.products.data);
            GAViewItemList(success.products.data);
            eSputnik.CategoryPage({
              categoryKey: window.categoryKey || 0
            });

            const seoTextBlockLayout = document.querySelector(".block-seo");
            if (!seoTextBlockLayout ) {
              const seoTextBlockLayout = '<div class="block-seo"><div class="wrapper js_seo_container"><div class="js_seo_content"></div></div></div>'
              const hitsBlock = document.querySelector(".js_product-hits");
              hitsBlock.insertAdjacentHTML("afterend", seoTextBlockLayout);
            }
            if (success.meta_data?.seotext) {
              const seoTextContent = document.querySelector(".js_seo_content");
              seoTextContent.innerHTML = success.meta_data.seotext;
            } else {
              seoTextBlockLayout?.remove();
            }

            if (scrollToTop) {
              $("html, body").animate({ scrollTop: 0 }, 300);
            }
          },
          error: (error) => {
            console.log(error);
          },
        }).always(() => {
          preloader(false);
        });

      }, delay);
    };

    window.addEventListener("popstate", () => {
      document.location.reload();
      if (showMoreWasUsed) {
        $("html, body").animate({ scrollTop: 0 }, 300)
      }
    });

    const categoryLineNavigate = () => {
      document.addEventListener("click", (e) => {
        if (e.target.matches(".catalogue-categories__link")) {
          e.preventDefault();
          getSlug = e.target.dataset.slug;
          page = 1;
          generateQuery();
        }
      });
    };

    const filtersChange = () => {
      document.addEventListener('click', function preventDefaultOnClickLink(e) {
        if (e.target.closest('.catalogue-aside__menu .checkbox a')) {
          e.preventDefault();
        }
      });

      document.addEventListener('click', function handleCheckboxClick(e) {
        if (e.target.closest('.catalogue-aside__menu label.checkbox')) {
          e.preventDefault();

          const input = e.target
            .closest('.catalogue-aside__menu label.checkbox')
            .querySelector('input');
          input.checked = !input.checked;

          const filterBlock = e.target.closest('.aside-item');
          const checkedLength = filterBlock.querySelectorAll('input:checked').length;
          const filterTitle = filterBlock.querySelector('.aside-item__title');

          filterTitle?.classList[checkedLength ? 'add' : 'remove'](
            'has-selected'
          );
          showMoreWasUsed && deleteProductCardsFromList()
          page = 1;
          generateQuery(true, true, PRODUCT_REQUEST_DELAY);
        }
      });
    };

    const setPrice = () => {
      const button = $(".aside-item.slider-item .btn-white");

      button.on("click", () => {
        const priceInputMin = $("#minInput");
        const priceInputMax = $("#maxInput");
        const priceInputMinValue = +priceInputMin.val();
        const priceInputMaxValue = +priceInputMax.val();
        const priceSlider = $("#slider");
        const priceSliderMinValue = +priceSlider.attr("data-min");
        const priceSliderMaxValue = +priceSlider.attr("data-max");
        const priceSliderSelectedMinValue = +priceSlider.attr(
          "data-selected-min"
        );
        const priceSliderSelectedMaxValue = +priceSlider.attr(
          "data-selected-max"
        );
        const applyButton = document.querySelector(
          ".aside-item.slider-item > .wb-btn.btn-white"
        );
        const priceFilterTranslations = JSON.parse(
          applyButton.dataset.translation
        );

        // if selected range is the same as already filtered range => do nothing
        if (
          priceInputMaxValue === priceSliderSelectedMaxValue &&
          priceInputMinValue === priceSliderSelectedMinValue
        )
          return;

        // reset price markup and filter page
        priceFilterMarkup = "";
        page = 1;

        // if selected range is the same as min/max filter values => remove price filter
        if (
          priceInputMaxValue === priceSliderMaxValue &&
          priceInputMinValue === priceSliderMinValue
        ) {
          price = "";
          priceFilterMarkup = "";
        } else if (
          priceInputMaxValue < priceSliderMaxValue &&
          priceInputMinValue === priceSliderMinValue
        ) {
          // if only max value is changed => filter only by max value
          price = `max-price-${priceInputMaxValue}/`;
          selectedFilterLayout(
            priceFilterTranslations.price,
            `${priceFilterTranslations.to}: <strong>${priceInputMaxValue}</strong>`,
            "max-price",
            true
          );
        } else if (
          priceInputMaxValue === priceSliderMaxValue &&
          priceInputMinValue > priceSliderMinValue
        ) {
          // if only min value is changed => filter only by min value
          price = `min-price-${priceInputMinValue}/`;
          selectedFilterLayout(
            priceFilterTranslations.price,
            `${priceFilterTranslations.from}: <strong>${priceInputMinValue}</strong>`,
            "min-price",
            true
          );
        } else {
          // if both min and max values are changed => filter by min and max values
          price = `min-price-${priceInputMinValue}/max-price-${priceInputMaxValue}/`;
          selectedFilterLayout(
            priceFilterTranslations.price,
            `${priceFilterTranslations.from} <strong>${priceInputMinValue}</strong> ${priceFilterTranslations.to} <strong>${priceInputMaxValue}</strong>`,
            "priceRange",
            true
          );
        }
        showMoreWasUsed && deleteProductCardsFromList()
        generateQuery(true);
      });
    };

    const setGetParam = () => {
      const sortSelect = $(".sort-menu select");

      $(document)
        .on(
          "click",
          ".catalogue-list__pagination:not(.disabled) .pagination li:not(.dots):not(.active)",
          function countPagination() {
            const oldPagin = +page;
            const firstValue = +$(".pagination .first a").text();
            const lastValue = +$(".pagination .last a").text();
            const $this = $(this);

            if (!$this.hasClass("pagination-button")) {
              page = +$this.find("a").text();
            } else {
              const currentPagination = Number($(".pagination li.active a").last().text());

              if (
                $this.hasClass("prev") &&
                currentPagination - 1 >= firstValue
              ) {
                page = currentPagination - 1;
              } else if (
                $this.hasClass("next") &&
                currentPagination + 1 <= lastValue
              ) {
                page = currentPagination + 1;
              }
            }

            if (oldPagin !== +page) {
              showMoreWasUsed && deleteProductCardsFromList()
              if (+page === 1) {
                generateQuery(true, true, 0, "full");
              } else {
                generateQuery(true, true, 0, "products");
              }
            }

            paginationHolder.addClass("disabled");
          }
        )
        .on("click", ".pagination li", (event) => {
          event.preventDefault();
        });

      sortSelect.on("change", function getSortValue() {
        const $this = $(this);
        const value = $this.val();

        page = 1;
        sortValue = value === "default" ? "" : `?sort=${value}`;
        showMoreWasUsed && deleteProductCardsFromList()
        if (value !== "default") {
          generateQuery(true, true, 0, "products");
        } else {
          generateQuery(false, true, 0, "full");
        }
      });
    };

    const showMore = () => {
      $(document).on(
        "click",
        ".catalogue-list__pagination:not(.disabled) .btn-white",
        function showMoreProducts() {
          const $this = $(this);
          const lastValue = lastPageCount;

          if (!(+page + 1 <= lastValue)) {
            return;
          }

          paginationHolder.addClass("disabled");
          setTimeout(renderSkeletonProducts, 0)

          page = +page + 1;
          isMore = true;
          showMoreWasUsed = true;

          generateQuery(false, true, 0, "products");

          if (page >= lastValue) {
            $this.hide();
          }
        }
      );
    };

    const removeFilter = () => {
      $(document).on(
        "click",
        ".selected-filters .filter",
        function clearFilterOnClick() {
          const $this = $(this);
          const filterCode = $this.attr("data-code");
          page = 1;

          // if filter is price range => reset price range
          if (
            filterCode === "min-price" ||
            filterCode === "max-price" ||
            filterCode === "priceRange"
          ) {
            const minInput = $("#minInput");
            const maxInput = $("#maxInput");
            const slider = $("#slider");
            const minValue = slider.attr("data-min");
            const maxValue = slider.attr("data-max");

            // reset price filter inputs
            minInput.val(minValue);
            maxInput.val(maxValue);

            // reset price filters' variables
            price = "";
            priceFilterMarkup = "";

            generateQuery(true);
          } else {
            $(`input#${filterCode}`).prop("checked", false);
            generateQuery(true);
          }
        }
      );
    };

    const clearFilters = () => {
      $(document).on(
        "click",
        ".mobile-menu__head .remove,.catalogue-nav__selected .remove",
        (e) => {
          e.preventDefault();

          // deselect all filters' checkboxes
          $('.aside-item input[type="checkbox"]:checked').prop(
            "checked",
            false
          );

          // reset price filter inputs
          const minInput = $("#minInput");
          const maxInput = $("#maxInput");
          const slider = $("#slider");
          const minValue = slider.attr("data-min");
          const maxValue = slider.attr("data-max");
          minInput.val(minValue);
          maxInput.val(maxValue);

          // reset filters' variables
          price = "";
          priceFilterMarkup = "";
          filtersArr = [];
          page = 1;

          // run query with disabled filters
          generateQuery(true, false);
        }
      );
    };

    categoryLineNavigate();
    clearFilters();
    removeFilter();
    filtersChange();
    showMore();
    setGetParam();
    setPrice();
  };

  ajaxListingPagination();
  sliderInit();
  showMoreFilters();
  openFilterMenu();
  showSortMenu();
  mobileMenu();
};
export default catalogue;
